(async function(){
  function euro(v){
    return new Intl.NumberFormat('it-IT',{style:'currency',currency:'EUR',maximumFractionDigits:0}).format(v || 0);
  }
  function cleanText(html){
    return String(html || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function detectBrand(product){
    const title = String(product.title || '');
    const vendor = String(product.vendor || '');
    const slug = String(product.handle || '');
    const body = String(product.body_html || '');
    const brands = ['Dior','Chanel','Gucci','Casadei','Hermès','Hermes','Prada','Saint Laurent','YSL','Valentino','Louis Vuitton','Judith Leiber'];
    for (const brand of brands) {
      const b = brand.toLowerCase();
      if (title.toLowerCase().includes(b) || vendor.toLowerCase().includes(b) || slug.toLowerCase().includes(b) || body.toLowerCase().includes(b)) {
        if (brand === 'Hermes') return 'Hermès';
        if (brand === 'YSL') return 'Saint Laurent';
        return brand;
      }
    }
    if (title.toLowerCase().includes('gg marmont') || slug.toLowerCase().includes('gg-marmont')) return 'Gucci';
    if (title.toLowerCase().includes('miss dio')) return 'Dior';
    if (vendor && vendor.toLowerCase() !== 'bottegaretail' && vendor.toLowerCase() !== 'elleci-sport') return vendor;
    return 'Bottega Retail';
  }
  function detectGroupCategory(product){
    const title = String(product.title || '').toLowerCase();
    const slug = String(product.handle || '').toLowerCase();
    const ptype = String(product.product_type || '').toLowerCase();
    const tags = Array.isArray(product.tags) ? product.tags.join(' ').toLowerCase() : String(product.tags || '').toLowerCase();
    const body = String(product.body_html || '').toLowerCase();

    const careKw = ['care','kit pulizia','elisir detergente','crema nutriente','spray protettivo','pulizia pelli'];
    const shoeKw = ['scarpe','scarpa','pumps','sandali','sandals','blade','tacco','stivali','stivaletti','sneakers','calzature','loafer','mocassini','decollete'];
    const accKw = ['cintura','portafoglio','wallet','occhiali','accessorio','accessori','sciarpa','foulard','cappello','bijoux','portachiavi','gift card'];
    const bagKw = ['borsa','borse','bag','handbag','saddle','lady dior','marmont','flap','kate','envelope','evelope','alma','miss caro','miss dio','tracolla','spalla','clutch','tote'];

    if (careKw.some(k => ptype.includes(k) || tags.includes(k) || title.includes(k) || slug.includes(k))) {
      return 'Care';
    }
    if (shoeKw.some(k => ptype.includes(k) || tags.includes(k)) || accKw.some(k => ptype.includes(k) || tags.includes(k))) {
      return 'Scarpe ed Accessori';
    }
    if (bagKw.some(k => ptype.includes(k) || tags.includes(k))) {
      return 'Borse';
    }
    if (shoeKw.some(k => title.includes(k) || slug.includes(k)) || accKw.some(k => title.includes(k) || slug.includes(k))) {
      return 'Scarpe ed Accessori';
    }
    if (bagKw.some(k => title.includes(k) || slug.includes(k))) {
      return 'Borse';
    }
    if (shoeKw.some(k => body.includes(k)) || accKw.some(k => body.includes(k))) {
      return 'Scarpe ed Accessori';
    }
    return 'Borse';
  }

  const CARE_FALLBACK_PRODUCTS = [
    {
      slug: 'care-kit-completo-bottega-retail',
      title: 'Kit Completo Pulizia Pelli Pregiate',
      brand: 'Bottega Retail Care',
      category: 'Care',
      group_category: 'Care',
      price: 85,
      price_str: '€ 85',
      image: '',
      story: "Set professionale completo per la detersione, l'idratazione e la protezione di borse e accessori in pelle pregiata.",
      product_url: 'https://wa.me/393932609234?text=Salve,%20vorrei%20acquistare%20il%20Kit%20Completo%20Pulizia%20Pelli%20Pregiate%20Bottega%20Retail%20(%E2%82%AC%2085).',
      checkout_url: 'https://wa.me/393932609234?text=Salve,%20vorrei%20acquistare%20il%20Kit%20Completo%20Pulizia%20Pelli%20Pregiate%20Bottega%20Retail%20(%E2%82%AC%2085).'
    },
    {
      slug: 'care-elisir-detergente-delicato',
      title: 'Elisir Detergente Delicato 150ml',
      brand: 'Bottega Retail Care',
      category: 'Care',
      group_category: 'Care',
      price: 32,
      price_str: '€ 32',
      image: '',
      story: 'Formula micellare a pH bilanciato per rimuovere impurità dalle pelli più sensibili.',
      product_url: 'https://wa.me/393932609234?text=Salve,%20vorrei%20acquistare%20l%27Elisir%20Detergente%20Delicato%20150ml%20Bottega%20Retail%20(%E2%82%AC%2032).',
      checkout_url: 'https://wa.me/393932609234?text=Salve,%20vorrei%20acquistare%20l%27Elisir%20Detergente%20Delicato%20150ml%20Bottega%20Retail%20(%E2%82%AC%2032).'
    },
    {
      slug: 'care-crema-nutriente-rigenerante',
      title: 'Crema Nutriente Rigenerante 100ml',
      brand: 'Bottega Retail Care',
      category: 'Care',
      group_category: 'Care',
      price: 38,
      price_str: '€ 38',
      image: '',
      story: 'Emulsione ricca a base di cere naturali per restituire morbidezza ed elasticità ai pellami.',
      product_url: 'https://wa.me/393932609234?text=Salve,%20vorrei%20acquistare%20la%20Crema%20Nutriente%20Rigenerante%20100ml%20Bottega%20Retail%20(%E2%82%AC%2038).',
      checkout_url: 'https://wa.me/393932609234?text=Salve,%20vorrei%20acquistare%20la%20Crema%20Nutriente%20Rigenerante%20100ml%20Bottega%20Retail%20(%E2%82%AC%2038).'
    },
    {
      slug: 'care-spray-protettivo-impermeabilizzante',
      title: 'Spray Protettivo Impermeabilizzante 150ml',
      brand: 'Bottega Retail Care',
      category: 'Care',
      group_category: 'Care',
      price: 28,
      price_str: '€ 28',
      image: '',
      story: 'Barriera invisibile traspirante contro umidità e macchie accidentali.',
      product_url: 'https://wa.me/393932609234?text=Salve,%20vorrei%20acquistare%20lo%20Spray%20Protettivo%20Impermeabilizzante%20150ml%20Bottega%20Retail%20(%E2%82%AC%2028).',
      checkout_url: 'https://wa.me/393932609234?text=Salve,%20vorrei%20acquistare%20lo%20Spray%20Protettivo%20Impermeabilizzante%20150ml%20Bottega%20Retail%20(%E2%82%AC%2028).'
    }
  ];

  window.scrollBrCarousel = function(trackId, dir){
    const track = document.getElementById(trackId);
    if (!track) return;
    const card = track.querySelector('.card');
    const step = card ? (card.offsetWidth + 22) * 2 : 560;
    track.scrollBy({ left: dir * step, behavior: 'smooth' });
  };

  // Pop-up Modals (Chi siamo & Contatti) + Mobile Menu links
  function openModal(name){
    const modal = document.getElementById('modal-' + name);
    if (!modal) return;
    modal.classList.add('open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.remove('br-menu-open');
  }

  function closeAllModals(){
    document.querySelectorAll('.br-modal-overlay.open').forEach(m => {
      m.classList.remove('open');
      m.setAttribute('aria-hidden', 'true');
    });
  }

  document.addEventListener('click', function(e){
    const trigger = e.target.closest('[data-open-modal]');
    if (trigger) {
      e.preventDefault();
      openModal(trigger.getAttribute('data-open-modal'));
      return;
    }
    const closeBtn = e.target.closest('[data-close-modal]');
    if (closeBtn) {
      e.preventDefault();
      closeAllModals();
      return;
    }
    if (e.target.classList && e.target.classList.contains('br-modal-overlay')) {
      closeAllModals();
    }
  });

  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape') {
      closeAllModals();
      document.body.classList.remove('br-menu-open');
    }
  });

  async function loadProducts(){
    try {
      const res = await fetch('/products.json?limit=250', {credentials:'same-origin'});
      const raw = await res.json();
      const items = Array.isArray(raw.products) ? raw.products : [];
      const mapped = items.map(p => {
        const variant = (p.variants || []).find(v => v.available) || (p.variants || [])[0] || {};
        const variantId = variant.id || null;
        const price = Number.parseFloat(variant.price || '0') || 0;
        const image = ((p.images || [])[0] || {}).src || '';
        const groupCategory = detectGroupCategory(p);
        return {
          slug: p.handle,
          title: p.title,
          brand: detectBrand(p),
          category: groupCategory,
          group_category: groupCategory,
          price,
          price_str: euro(price),
          image,
          story: cleanText(p.body_html),
          variant_id: variantId,
          product_url: '/products/' + p.handle,
          checkout_url: variantId ? ('/cart/' + variantId + ':1') : ('/products/' + p.handle)
        };
      });
      const hasCare = mapped.some(x => x.group_category === 'Care');
      return hasCare ? mapped : mapped.concat(CARE_FALLBACK_PRODUCTS);
    } catch (e) {
      console.error('loadProducts error', e);
      return CARE_FALLBACK_PRODUCTS;
    }
  }

  const products = await loadProducts();
  const currentCollection = (window.BR_COLLECTION_HANDLE || 'all').toLowerCase();

  function renderCard(p){
    const isCare = p.group_category === 'Care';
    const imgMarkup = p.image
      ? `<div class="card-image"><img src="${p.image}" alt="${p.title}"></div>`
      : `<div class="card-image--empty"><span>Bottega Retail Care</span></div>`;
    const actionsMarkup = isCare
      ? `<div class="card-actions card-actions--single">
           <a class="btn dark" href="${p.checkout_url}" target="_blank" rel="noopener">Acquista</a>
         </div>`
      : `<div class="card-actions">
           <a class="btn dark" href="${p.checkout_url}">Acquista</a>
           <a class="btn light" href="/pages/vendi-il-tuo-prodotto">Vendi la tua</a>
         </div>`;

    return `
      <div class="card">
        <a href="${p.product_url}" class="card-link">
          ${imgMarkup}
        </a>
        <div class="copy">
          <small class="meta">${p.brand} · ${p.group_category}</small>
          <h3><a href="${p.product_url}">${p.title}</a></h3>
          <div class="price">${euro(p.price)}</div>
          ${actionsMarkup}
        </div>
      </div>`;
  }

  // 1. Home: Nuovi Arrivi (Borse carousel)
  const homeCarousel = document.getElementById('home-bags-carousel');
  if (homeCarousel) {
    const bagItems = products.filter(p => p.group_category === 'Borse');
    homeCarousel.innerHTML = bagItems.map(renderCard).join('');
  }

  // 2. Care Landing: Care products carousel
  const careCarousel = document.getElementById('care-carousel');
  if (careCarousel) {
    const careItems = products.filter(p => p.group_category === 'Care');
    careCarousel.innerHTML = careItems.map(renderCard).join('');
  }

  // 3. Shop Page: 4 Category Buttons ("Tutti", "Borse", "Scarpe ed Accessori", "Care") + Brand & Price filters
  const grid = document.getElementById('grid');
  const brandSelect = document.getElementById('filter-brand');

  if (brandSelect) {
    const uniqueBrands = Array.from(new Set(products.map(p => p.brand).filter(Boolean))).sort((a,b)=>a.localeCompare(b,'it'));
    brandSelect.innerHTML = '<option value="all">Tutte le marche</option>' +
      uniqueBrands.map(b => '<option value="' + b.replace(/"/g, '&quot;') + '">' + b + '</option>').join('');
  }

  const params = new URLSearchParams(location.search);
  let activeCat = 'all';
  let activeBrand = params.get('brand') || 'all';
  let activePrice = 'price-desc';

  if (currentCollection === 'borse') activeCat = 'Borse';
  else if (currentCollection === 'care') activeCat = 'Care';
  else if (currentCollection.includes('scarpe') || currentCollection.includes('accessori')) activeCat = 'Scarpe ed Accessori';

  const catParam = (params.get('cat') || params.get('category') || '').toLowerCase();
  if (catParam === 'borse') activeCat = 'Borse';
  else if (catParam === 'care' || catParam.includes('pulizia')) activeCat = 'Care';
  else if (catParam.includes('scarpe') || catParam.includes('accessori')) activeCat = 'Scarpe ed Accessori';

  if (brandSelect && activeBrand !== 'all') {
    brandSelect.value = activeBrand;
  }

  function updateCatPillsUI(){
    const map = {
      'all': 'btn-cat-all',
      'Borse': 'btn-cat-borse',
      'Scarpe ed Accessori': 'btn-cat-scarpe-accessori',
      'Care': 'btn-cat-care'
    };
    Object.entries(map).forEach(([cat, id]) => {
      const el = document.getElementById(id);
      if (el) el.classList.toggle('active', activeCat === cat);
    });
  }

  window.setShopCategory = function(cat){
    activeCat = cat;
    updateCatPillsUI();
    renderShopGrid();
  };

  window.setShopBrand = function(brand){
    activeBrand = brand || 'all';
    renderShopGrid();
  };

  window.setShopSort = function(priceVal){
    activePrice = priceVal || 'price-desc';
    renderShopGrid();
  };

  function renderShopGrid(){
    if (!grid) return;

    let list = products.slice();

    if (activeCat !== 'all') {
      list = list.filter(p => p.group_category === activeCat);
    }

    if (activeBrand && activeBrand !== 'all') {
      list = list.filter(p => (p.brand || '').toLowerCase() === activeBrand.toLowerCase());
    }

    if (activePrice === 'under-500') {
      list = list.filter(p => p.price <= 500).sort((a,b) => a.price - b.price);
    } else if (activePrice === '500-1500') {
      list = list.filter(p => p.price >= 500 && p.price <= 1500).sort((a,b) => a.price - b.price);
    } else if (activePrice === 'over-1500') {
      list = list.filter(p => p.price > 1500).sort((a,b) => b.price - a.price);
    } else if (activePrice === 'price-asc') {
      list.sort((a,b) => a.price - b.price);
    } else {
      list.sort((a,b) => b.price - a.price);
    }

    if (!list.length) {
      grid.innerHTML = '<p style="grid-column:1/-1;text-align:center;color:var(--soft);padding:32px 0;">Nessun articolo trovato per i filtri selezionati.</p>';
      return;
    }

    grid.innerHTML = list.map(renderCard).join('');
  }

  if (grid) {
    updateCatPillsUI();
    renderShopGrid();
  }
})();
